<template>
    <div :class="{ disabled_option: disabled }" @click.capture="guardDisabledClick">
        <div class="row_center_between w-full">
            <text v-if="cancelable && isSelected && !disabled" id="close" class="button-icon cancel_icon">close</text>
            <div class="row_center_start grow flex-wrap">
                <div class="grow">
                    <text>{{ displayName }}</text>
                    <text class="shrink-0" v-if="product['altAddonPrice'] !== undefined && product.altAddonPrice !== 0">{{
                        formatPriceChange(product.altAddonPrice) }}</text>
                    <!-- 一般商品規格價格 -->
                    <text class="shrink-0"
                        v-else-if="product['altAddonPrice'] === undefined && product.price !== 0 && !isProduct">{{
                        product.price > 0 ? `+${product.price}` : product.price }}</text>
                    <text class="stock_text" :class="{ sold_out: isSoldOut }" v-if="showStock">
                        {{ isSoldOut ? '售完' : `剩餘數量：${product.stockCount}` }}
                    </text>
                </div>
                <text class="text-primary-color text-base"
                    v-if="editable && !disabled" @click="openCustomizePopup">選擇規格</text>
            </div>
        </div>
        <div class="column_start_start customized_options" v-if="isSelected && customizedText">
            {{ customizedText }}
        </div>
    </div>
</template>
<script>
import { getFrontEndName, getSpecOptionFrontEndName, getSpecFrontEndName } from "@/utils/productName.utils";
export default {
    props: {
        product: {
            type: Object,
            default: () => {
                return {};
            },
            required: true,
        },
        editable: {
            type: Boolean,
            default: false,
            required: false,
        },
        isSelected: {
            type: Boolean,
            default: false
        },
        disabled: {
            type: Boolean,
            default: false
        },
        cancelable: {
            type: Boolean,
            default: false
        },
        // true：此項為「規格選項」(基本名稱第1段)；false：為「商品/套餐子項」(前台顯示名稱第2段)
        isSpecOption: {
            type: Boolean,
            default: false
        }
    },
    computed: {
        displayName() {
            return this.isSpecOption
                ? getSpecOptionFrontEndName(this.product.name)
                : getFrontEndName(this.product.name)
        },
        showStock() {
            return Number(this.product.stockMode) === 1 && this.product.stockCount !== null && this.product.stockCount !== undefined
        },
        isSoldOut() {
            return this.product.isStockSoldOut || Number(this.product.stockCount) === 0
        },
        isProduct() {
            return this.products.find(item => item.id === this.product.id)
        },
        products() {
            return this.$store.getters['spreadsheet/products']
        },
        customizedText() {
            if (this.product.productSpecSettings === undefined) return '';
            let customizedText = '';
            this.product.productSpecSettings.forEach(el => {
                if (el.subSpecOptionSelectCount !== undefined) {
                    const totalCount = el.subSpecOptionSelectCount.reduce((acc, option) => acc + option, 0)
                    if (totalCount === 0) return;
                    let text = el.subSpecOptionSelectCount.reduce((text, count, index) => {
                        if (el.specOptions === undefined || count === 0) return text;
                        return text += `${getSpecOptionFrontEndName(el.specOptions[index].name)} ${count > 1 ? `x${count}` : ''}/`;
                    }, '');
                    if (text) {
                        customizedText += `${getSpecFrontEndName(el)}：${text.slice(0, -1)}、`;
                    }
                }
            });
            return customizedText ? customizedText.slice(0, -1) : '';
        }
    },
    methods: {
        formatPriceChange(price) {
            return price > 0 ? `+${price}` : price
        },
        guardDisabledClick(event) {
            if (!this.disabled) return
            event.stopPropagation()
            event.preventDefault()
        },
        openCustomizePopup() {
            if (this.disabled) return
            this.$emit("openCustomizePopup");
        }
    }
}
</script>
<style lang="scss">
.stock_text {
    display: inline-block;
    margin-left: 8px;
    color: #666666;
    font-size: 14px;
}

.stock_text.sold_out {
    color: #D60A0A;
}

.disabled_option {
    opacity: 0.45;
}

.cancel_icon {
    color: #FD4F02;
    font-size: 22px;
    margin-right: 8px;
    flex-shrink: 0;
}

</style>
